import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box, IconButton } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import StartSharpIcon from '@mui/icons-material/PlayCircleOutline';

const iconMap: Record<string, JSX.Element> = {
  TASK: <AssignmentTurnedInIcon />,
  REVIEW: <ContentPasteSearchIcon />,
  output: <SportsScoreIcon />,
  input: <StartSharpIcon />
};

export const CustomNode = ({ data }: any) => {
  let type = data?.category;

  if (data?.type === 'end') {
    type = 'output';
  }

  if (data?.type === 'start') {
    type = 'input';
  }

  const shouldRenderIconBox =
    data?.category === 'TASK' || data?.category === 'REVIEW' || data?.type === 'start' || data?.type === 'end';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '14px 20px',
        borderRadius: '12px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
        fontWeight: 500,
        fontSize: '14px',
        color: '#333',
        minWidth: '220px',
        cursor: 'pointer'
      }}
    >
      {shouldRenderIconBox && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '30px',
            height: '30px',
            backgroundColor: type === 'TASK' ? '#0063B2' : type === 'REVIEW' ? '#9CC3D5' : 'lightpink',
            borderRadius: '8px',
          }}
        >
          <IconButton sx={{ color: 'white' }}>
            {iconMap[type]}
          </IconButton>
        </Box>
      )}

      <Box sx={{ marginTop: '2px', fontSize: '16px', fontWeight: 'normal' }}>
        {data?.label}
      </Box>
      {data?.type !== 'start' && (
        <Handle type="target" position={Position.Top} />
      )}

      {data?.type !== 'end' && (
        <Handle type="source" position={Position.Bottom} />
      )}

    </div>
  );
};
